import React from 'react';

import { asyncAwaitData } from 'data/javascript/async';

import DescriptionEntry from 'components/shared/description-entry';

const TryCatch = () => {
  const item = asyncAwaitData?.items.find(
    (item) => item.title === 'Try-Catch'
  );

  return <DescriptionEntry entry={item} />;
};

export default TryCatch;
